import { createContext } from "react"

export const MeteredElectricContext = createContext(null)
